import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const RedirectToStatic: React.FC<{ path?: string; url?: string }> = (props) => {
  const { path, url } = props;
  const navigate = useNavigate();
  useEffect(() => {
    if (path) {
      navigate(path);
    } else if (url) {
      window.location.href = url;
    }
  }, [path, url, navigate]);
  return null;
};
